<template>
	<div>
		<md-dialog :md-active="show" style="font-family: 'Montserrat', sans-serif; height: 500px; top: 25%">
			<div class="dialog" style="background-color: #eeeeee">
				<div class="dialog-header">
					<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">{{
						$t("new-subscription")
					}}</span>
					<div style="margin-left: auto; margin-right: 0px">
						<md-button @click="close" class="md-icon-button" style="margin-right: -5px">
							<md-icon style="color: white">close</md-icon>
						</md-button>
					</div>
				</div>
				<div class="dialog-body" style="width: 100%">
					<subscriptions-form :subscription="item" :error="error" :editable="true" />
				</div>
				<div class="dialog-footer">
					<div style="margin-left: auto; margin-right: 0px">
						<md-button class="cancel" @click="close">{{ $t("cancel") }}</md-button>
						<md-button class="add" @click="handleAdd">
							<i class="el-icon-loading" v-if="loading" />
							<span>{{ $t("add") }}</span>
						</md-button>
					</div>
				</div>
			</div>
		</md-dialog>
	</div>
</template>

<script>
import { mapActions } from "vuex"
import { CURRENCY } from "@/utils/utils"
import SubscriptionForm from "@/modules/datas/subscriptions/subscriptions-components/subscriptions-form.vue"

export default {
	components: {
		"subscriptions-form": SubscriptionForm
	},
	name: "subscriptions-add",
	props: ["show"],
	data() {
		return {
			CURRENCY,
			loading: false,
			item: undefined,
			error: []
		}
	},
	created() {
		this.reset()
	},
	methods: {
		...mapActions({
			doAdd: "subscription/doAdd"
		}),
		close: function () {
			this.$emit("close")
		},
		reset: function () {
			this.item = {
				name: "",
				price: 0.0,
				duration_month: 0,
				currency: "EUR",
				visible: true,
				ticketing: false,
				areas: []
			}
		},
		handleAdd: function () {
			this.error = []
			if (this.item.name == "") this.error.push("name")
			if (this.item.duration_month == 0) this.error.push("duration")

			if (this.error.length > 0) return

			this.saving = true
			var payload = {
				name: this.item.name,
				price: this.item.price ? this.item.price : 0.0,
				duration_month: this.item.duration_month,
				currency: this.item.currency,
				areas: this.item.areas,
				visible: this.item.visible,
				ticketing: this.item.ticketing
			}

			this.add(payload)
		},

		async add(payload) {
			var result = await this.doAdd(payload)
			if (result.status) {
				this.$notification("success", this.$t("save-successful"), "", 4000)
			} else {
				this.$processError(this.$t("save-error"), err.response.data.Message)
			}
			this.reset()
			this.$emit("close")
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/my-dialog";
</style>
